const MuiInput = {
  styleOverrides: {
    root: {
      '&.MuiFilledInput-root': {
        backgroundColor: 'transparent',
      },
      '&:-internal-autofill-selected': {
        backgroundColor: 'transparent',
      },
    },
  },
};

export default MuiInput;
